import React, { FC, useState, useRef, useEffect, CSSProperties } from 'react'

type ResizableProps = {
    onResize?: (width: number) => void
    children: React.ReactNode
    className?: string
    style?: CSSProperties
}

export const Resizable: FC<ResizableProps> = ({ onResize, children, className, style }) => {
    const [width, setWidth] = useState(500)
    const resizableRef = useRef<HTMLDivElement>(null)
    const isResizing = useRef(false)

    const handleMouseDown = () => {
        isResizing.current = true
    }

    const handleMouseMove = (e: MouseEvent) => {
        if (isResizing.current && resizableRef.current) {
            const newWidth = e.clientX - resizableRef.current.getBoundingClientRect().left
            if (newWidth < 500) return
            setWidth(newWidth)
            onResize && onResize(newWidth)
        }
    }

    const handleMouseUp = () => {
        isResizing.current = false
    }

    useEffect(() => {
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleMouseUp)
        return () => {
            document.removeEventListener('mousemove', handleMouseMove)
            document.removeEventListener('mouseup', handleMouseUp)
        }
    })

    return (
        <div ref={resizableRef} style={Object.assign({}, style, { width })} className={className}>
            {children}
            <div
                onMouseDownCapture={handleMouseDown}
                className={
                    'flex min-h-full min-w-1 bg-mm-bg3/80 backdrop-blur-md hover:bg-mm-border transition-colors border-r cursor-col-resize'
                }
            />
        </div>
    )
}
